import {
    AutocompleteTaskDefs,
    AutocompleteReducerAction,
    AutocompleteState,
} from '../types';

export const AutocompleteReducer = <ResultEntry, Value>(
    state: AutocompleteState<ResultEntry, Value>,
    action: AutocompleteReducerAction<ResultEntry, Value>
): AutocompleteState<ResultEntry, Value> => {
    switch (action.type) {
        case AutocompleteTaskDefs.SetThreshold:
            return {
                ...state,
                lastModified: action.payload.timestamp,
                config: {
                    ...state.config,
                    threshold: action.payload.value,
                },
            };
        case AutocompleteTaskDefs.SetValue:
        case AutocompleteTaskDefs.Reset:
            return {
                ...state,
                currentValue: action.payload.value,
                recentValue: state.currentValue,
                lastModified: action.payload.timestamp,
            };
        case AutocompleteTaskDefs.SetResults:
            return {
                ...state,
                results: action.payload.value,
                lastModified: action.payload.timestamp,
            };
        case AutocompleteTaskDefs.Clear:
            return {
                ...state,
                currentValue: new Set(),
                results: undefined,
                recentValue: state.currentValue,
                lastModified: action.payload.timestamp,
            };
    }
};
